module.exports = __webpack_public_path__ + "static/media/Nexus 9.a5f71b28.png";